import React, { JSX } from 'react';
import { ApiPrice, ApiPriceType } from '@ibe/api';
import { PriceListItemLayout } from '../../Components/Layouts/ListItemLayout/ThreeColumnListItemLayout/PriceListItemLayout';
import fallback from '../../../_Translations/generated/package-details.en.t.json';
import Keys from '../../../_Translations/generated/package-details.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';

const PackageInfo = ({
  price,
  duration,
  board,
  room,
  origin,
  className
}: {
  price: ApiPrice;
  duration?: number;
  board?: string;
  room?: string;
  origin?: string;
  className?: string;
}): JSX.Element => {
  const { t } = useTranslation('package-details', fallback, Keys);

  return (
    <div className={`package-info ${className || ''}`}>
      <PriceListItemLayout
        totalPrice={price}
        showFromPrefix
        displayInline
        displayPriceSuffixExtraline
        priceType={ApiPriceType.PERSON}
        className="package-info__price float-right"
      />
      <div className="package-info__data">
        {!!duration && <div className="mb-1">{t(Keys.nights, { duration })}</div>}
        {!!board && <div className="mb-1">{board}</div>}
        {!!room && <div className="mb-1">{room}</div>}
        {!!origin && <div>{`${t(Keys.flightFrom)} ${origin}`}</div>}
      </div>
    </div>
  );
};

export default PackageInfo;
